import { useState, useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Tasks from "./pages/Tasks";
import TaskDetail from "./pages/TaskDetail";
import Clients from "./pages/Clients";
import Services from "./pages/Services";
import ActivityLog from "./pages/ActivityLog";
import TeamEfficiency from "./pages/TeamEfficiency";
import Timesheet from "./pages/Timesheet";
import Team from "./pages/Team";
import Holidays from "./pages/Holidays";
import Billing from "./pages/Billing";
import Reports from "./pages/Reports";
import Transfer from "./pages/Transfer";
import Shortcuts from "./pages/Shortcuts";
import LeaveCalendar from "./pages/LeaveCalendar";
import MemberWorkspace from "./pages/MemberWorkspace";
import HRDashboard from "./pages/HRDashboard";
import MyDocuments from "./pages/MyDocuments";
import MyProfile from "./pages/MyProfile";
import TeamHours from "./pages/TeamHours";
import AttendancePage from "./pages/AttendancePage";
import VarianceReport from "./pages/VarianceReport";
import CapacityPlanner from "./pages/CapacityPlanner";
import Layout from "./components/Layout";
import ErrorBoundary from "./components/ErrorBoundary";
import { Toaster } from "./components/ui/sonner";

function AuthRoute({ children }) {
  return (
    <Layout>
      <ErrorBoundary>{children}</ErrorBoundary>
    </Layout>
  );
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const isExpired = payload.exp && payload.exp * 1000 < Date.now();
        if (isExpired) {
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          setIsAuthenticated(false);
        } else {
          setIsAuthenticated(true);
        }
      } catch (err) {
        console.warn('Token parse failed, clearing session:', err);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        setIsAuthenticated(false);
      }
    } else {
      setIsAuthenticated(false);
    }
    setIsLoading(false);
  }, []);

  if (isLoading) {
    return <div className="flex items-center justify-center h-screen">Loading...</div>;
  }

  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const isMember = user.role === 'member';

  return (
    <div className="App h-full">
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={
            isAuthenticated ? <Navigate to="/" /> : <Login setIsAuthenticated={setIsAuthenticated} />
          } />
          <Route path="/" element={isAuthenticated ? <AuthRoute>{isMember ? <MemberWorkspace /> : <Dashboard />}</AuthRoute> : <Navigate to="/login" />} />
          <Route path="/tasks" element={isAuthenticated ? <AuthRoute><Tasks /></AuthRoute> : <Navigate to="/login" />} />
          <Route path="/tasks/:taskId" element={isAuthenticated ? <AuthRoute><TaskDetail /></AuthRoute> : <Navigate to="/login" />} />
          <Route path="/clients" element={isAuthenticated ? <AuthRoute><Clients /></AuthRoute> : <Navigate to="/login" />} />
          <Route path="/services" element={isAuthenticated ? <AuthRoute><Services /></AuthRoute> : <Navigate to="/login" />} />
          <Route path="/activity-log" element={isAuthenticated ? <AuthRoute><ActivityLog /></AuthRoute> : <Navigate to="/login" />} />
          <Route path="/team-efficiency" element={isAuthenticated ? <AuthRoute><TeamEfficiency /></AuthRoute> : <Navigate to="/login" />} />
          <Route path="/timesheet" element={isAuthenticated ? <AuthRoute><Timesheet /></AuthRoute> : <Navigate to="/login" />} />
          <Route path="/team" element={isAuthenticated ? <AuthRoute><Team /></AuthRoute> : <Navigate to="/login" />} />
          <Route path="/team-hours" element={isAuthenticated ? <AuthRoute><TeamHours /></AuthRoute> : <Navigate to="/login" />} />
          <Route path="/attendance" element={isAuthenticated ? <AuthRoute><AttendancePage /></AuthRoute> : <Navigate to="/login" />} />
          <Route path="/reports/variance" element={isAuthenticated ? <AuthRoute><VarianceReport /></AuthRoute> : <Navigate to="/login" />} />
          <Route path="/capacity" element={isAuthenticated ? <AuthRoute><CapacityPlanner /></AuthRoute> : <Navigate to="/login" />} />
          <Route path="/holidays" element={isAuthenticated ? <AuthRoute><Holidays /></AuthRoute> : <Navigate to="/login" />} />
          <Route path="/billing" element={isAuthenticated ? <AuthRoute><Billing /></AuthRoute> : <Navigate to="/login" />} />
          <Route path="/reports" element={isAuthenticated ? <AuthRoute><Reports /></AuthRoute> : <Navigate to="/login" />} />
          <Route path="/transfer" element={isAuthenticated ? <AuthRoute><Transfer /></AuthRoute> : <Navigate to="/login" />} />
          <Route path="/shortcuts" element={isAuthenticated ? <AuthRoute><Shortcuts /></AuthRoute> : <Navigate to="/login" />} />
          <Route path="/leave" element={isAuthenticated ? <AuthRoute><LeaveCalendar /></AuthRoute> : <Navigate to="/login" />} />
          <Route path="/hr" element={isAuthenticated ? <AuthRoute><HRDashboard /></AuthRoute> : <Navigate to="/login" />} />
          <Route path="/my-profile" element={isAuthenticated ? <AuthRoute><MyProfile /></AuthRoute> : <Navigate to="/login" />} />
          <Route path="/my-documents" element={isAuthenticated ? <AuthRoute><MyDocuments /></AuthRoute> : <Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;